import Grid from '@mui/material/Grid'
import cx from 'classnames'
import InfoToolTipIcon from './InfoToolTipIcon'
import Icon from 'components/shared/Icon'

interface Props {
  receiveNoNews: boolean
  handleChange: (value: boolean) => void
}

const SelectNoNewsOptIn = ({ receiveNoNews, handleChange }: Props): JSX.Element => (
  <Grid container alignItems='center' className='pv6 ph5 pr0-t' spacing={1}>
    <Grid item xs={12} sm={7} md={6}>
      <Grid container>
        <Grid item className='mr2'>
          <InfoToolTipIcon
            title='This option allows you to opt out of receiving no-news emails altogether.'
          />
        </Grid>
        <span>Opt in or out of no-news emails</span>
      </Grid>
    </Grid>
    <Grid item xs={12} sm={5} md={6}>
      <NoNewsRadioControls {...{ receiveNoNews, handleChange }} />
    </Grid>
  </Grid>
)

const NoNewsRadioControls = ({ receiveNoNews, handleChange }: Props): JSX.Element => (
  <Grid container className='w-100'>
    <Grid item className='flex items-center'>
      <SelectOpt
        checked={receiveNoNews}
        onChange={() => handleChange(true)}
        id='noNewsEmailsIn'
        label='In'
        className='mr6 mb0'
      />
    </Grid>
    <Grid item className='flex items-center ml5'>
      <SelectOpt
        checked={!receiveNoNews}
        onChange={() => handleChange(false)}
        id='noNewsEmailsOut'
        label='Out'
        className='mb0'
      />
    </Grid>
  </Grid>
)

interface SelectProps {
  checked: boolean
  onChange: () => void
}

const SelectOpt = ({ checked, onChange, id, label, className }: SelectProps & { id: string, className?: string, label: string }): JSX.Element => (
  <>
    <input
      className='dn' type='radio' name={id} id={id} value={id}
      {...{
        checked,
        onChange: () => {
          onChange()
        }
      }}
    />
    <label
      htmlFor={id}
      className={cx(
        className,
        'lighter flex items-center account-input-label pointer',
        { 'account-input-checked': checked }
      )}
    >
      <Icon
        className='mr2 w7'
        name={{
          'icon-checkbox-marked-circle-outline': checked,
          'icon-checkbox-blank-circle-outline': !checked
        }}
      />
      <span className={cx({ teal: checked })}>{label}</span>
    </label>
  </>
)

export default SelectNoNewsOptIn
